import * as React from 'react';
const SvgRoadmap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="#DA63AD"
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16 9a3 3 0 1 0-2.83-4H9a4 4 0 1 0 0 8h6a2 2 0 1 1 0 4h-4.17a3.001 3.001 0 1 0 0 2H15a4 4 0 0 0 0-8H9a2 2 0 1 1 0-4h4.17A3 3 0 0 0 16 9m0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRoadmap;
